import { type FC } from 'react';

import { Box } from '../Box';
import { Heading } from '../Typography';
import Reviews from './Reviews';

const ReviewsShowcase: FC = () => {
  const sampleData = {
    averageRating: 4.0,
    totalReviews: 14,
    items: [
      { label: 'Communication', rating: 4 },
      { label: 'Property', rating: 4 },
      { label: 'Lodging', rating: 4 },
      { label: 'Game Abundance', rating: 5 },
    ],
  };

  const highRatingData = {
    averageRating: 4.8,
    totalReviews: 25,
    items: [
      { label: 'Communication', rating: 5 },
      { label: 'Property', rating: 5 },
      { label: 'Lodging', rating: 4 },
      { label: 'Game Abundance', rating: 5 },
    ],
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-8)"
      p="var(--spacing-6)"
    >
      <Heading size="lg">Reviews Component Showcase</Heading>

      <Box display="flex" flexDirection="column" gap="var(--spacing-4)">
        <Heading size="md">Default Reviews</Heading>
        <Box maxWidth="400px">
          <Reviews {...sampleData} />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap="var(--spacing-4)">
        <Heading size="md">High Rating Reviews</Heading>
        <Box maxWidth="400px">
          <Reviews {...highRatingData} />
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" gap="var(--spacing-4)">
        <Heading size="md">Mobile Layout (320px width)</Heading>
        <Box
          maxWidth="320px"
          border="1px solid var(--color-neutral-200)"
          p="var(--spacing-4)"
        >
          <Reviews {...sampleData} />
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewsShowcase;
